import React from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';
import { Button, Col, DatePicker, Form, Row, Select } from 'antd';

import Divider from 'components/Divider';
import IntlMessages from 'util/IntlMessages';
import Title from 'components/BoxContainer/components/Title';
import { LAYOUT_BY_DEFAULT } from 'packages/dashboard/screens/EventsDashboard/constants';
import { PERIOD_OPTIONS } from './constants';
import { DT_PROCESS_TYPES } from '../../constants';

const { Item } = Form;

const IncidentTrackerFilters = ({ formName, form, onSubmit }) => {
  const filterRef = React.useRef(null);

  const onSave = (next = false) => {
    const values = form.getFieldsValue();
    if (next) {
      onSubmit({ values, processType: filterRef.current });
      return;
    }
    onSave(true);
  };

  return (
    <>
      <Form form={form} layout={LAYOUT_BY_DEFAULT} name={formName} onFinish={() => onSave()}>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Title.SubTitle value={<IntlMessages id="work.direction.filter.period.range.date" />} />
          </Col>
          <Col xs={24} sm={8} md={8} lg={8}>
            <Title.LabelForm value={<IntlMessages id="work.direction.filter.default.period" />} />
            <Item name="period">
              <Select
                onChange={() => {
                  form.setFieldsValue({ startDate: undefined, endDate: undefined });
                }}
                options={PERIOD_OPTIONS.filter(period => period.value !== 365)}
                className="gx-w-100"
                allowClear
              />
            </Item>
          </Col>
          <Col xs={24} sm={8} md={8} lg={8}>
            <Title.LabelForm value={<IntlMessages id="work.direction.filter.start.date" />} />
            <Item name="startDate">
              <DatePicker
                onChange={() => {
                  const period = form.getFieldValue('period');
                  if (period !== null) {
                    form.setFieldsValue({ period: null });
                  }
                }}
                getPopupContainer={trigger => trigger.parentNode}
                allowClear={true}
                className="gx-w-100"
                disabledDate={current => current && current > moment.now()}
                inputReadOnly
              />
            </Item>
          </Col>
          <Col xs={24} sm={8} md={8} lg={8}>
            <Title.LabelForm value={<IntlMessages id="work.direction.filter.end.date" />} />
            <Item noStyle shouldUpdate={(prev, curr) => prev.startDate !== curr.startDate}>
              {({ getFieldValue }) => (
                <Item name="endDate">
                  <DatePicker
                    onChange={() => {
                      const period = form.getFieldValue('period');
                      if (period !== null) {
                        form.setFieldsValue({ period: null });
                      }
                    }}
                    getPopupContainer={trigger => trigger.parentNode}
                    allowClear={true}
                    className="gx-w-100"
                    disabledDate={current =>
                      current &&
                      current <
                        moment(getFieldValue('startDate')?.format('YYYY-MM-DD'), 'YYYY-MM-DD')
                    }
                    inputReadOnly
                  />
                </Item>
              )}
            </Item>
          </Col>
        </Row>
        <Divider />
        <Row justify="end" gutter={[8, 8]}>
          <Col span={{ xs: 24, sm: 8, md: 8, lg: 8 }}>
            <Button
              block
              className="gx-mb-0"
              type="primary"
              htmlType="submit"
              onClick={() => {
                filterRef.current = DT_PROCESS_TYPES.ISSUES;
              }}
            >
              <IntlMessages id="button.search" />
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default React.memo(IncidentTrackerFilters);

IncidentTrackerFilters.propTypes = {
  formName: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
